import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'biz-view-delta-breadcrumb',
  templateUrl: './view-delta-breadcrumb.component.html',
  styleUrls: ['./view-delta-breadcrumb.component.scss']
})
export class ViewDeltaBreadcrumbComponent {
  @Input() selectedCount: number = 0;
  @Input() selectedItemName: string = '';
  @Input() isDownloading: boolean = false;
  @Input() hasDifferences: boolean = true;
  @Output() onDownloadSelected = new EventEmitter<void>();
  @Output() onTitleClick = new EventEmitter<void>();
  @Output() onViewDifferences = new EventEmitter<void>();

  download() {
    this.onDownloadSelected.emit();
  }

  viewDifferences() {
    this.onViewDifferences.emit();
  }
}
